export const useNicheError = ({ onRetry }) => {
  const handleRetry = () => {
    if (onRetry) {
      onRetry()
    }
  }
  return {
    onRetry: handleRetry,
  }
}
